import * as React from 'react';

const LoadingProvider = () => {
  return <div></div>;
};

export default LoadingProvider;
